import { Alert } from '@mui/material'
import { t } from 'i18next'
import type { Dispatch } from 'redux'

import http from 'common/http'
import { showModal } from 'actions/app'

export const startFarmReport = (data: {
  farmId?: number
  year: number
  format: string
  includeDryYield?: boolean
}) => {
  const url = '/report/farm'
  return (dispatch: Dispatch) =>
    http
      .post(url, data)
      .then((res) => {
        dispatch(
          showModal(
            <Alert severity="success">
              {t('report_request_message') || 'Request Received'}
            </Alert>,
            {},
          ),
        )
      })
      .catch((error) => {
        console.error('Failed to start farm report', error)
        dispatch(
          showModal(
            <Alert severity="error">
              {t('report_request_error_message') || 'Report request failed'}
            </Alert>,
            {},
          ),
        )
      })
}

export const startFieldReport = (data: {
  year: number
  format: string
  startDate?: string
  clientId?: number
  farmId?: number
  areaUnit?: 'ha' | 'ac'
  yieldUnit?: 'tonnes_ha' | 'tonnes_ac' | 'bu_ac' | 'kg_ha' | 'lbs_acre'
  totalYieldUnit?: 'bu' | 'tonne' | 'lbs' | 'kg'
}) => {
  const url = '/report/field'
  return (dispatch: Dispatch) =>
    http
      .post(url, data)
      .then((res) => {
        dispatch(
          showModal(
            <Alert severity="success">
              {t('report_request_message') || 'Request Received'}
            </Alert>,
            {},
          ),
        )
      })
      .catch((error) => {
        console.error('Failed to start field report', error)
        dispatch(
          showModal(
            <Alert severity="error">
              {t('report_request_error_message') || 'Report request failed'}
            </Alert>,
            {},
          ),
        )
      })
}

export const startHarvesterReport = (data: {
  year: number
  format: string
  startDate?: string
  clientId?: number
  farmId?: number
  areaUnit?: 'ha' | 'ac'
  yieldUnit?: 'tonnes_ha' | 'tonnes_ac' | 'bu_ac' | 'kg_ha' | 'lbs_acre'
  totalYieldUnit?: 'bu' | 'tonne' | 'lbs' | 'kg'
  speedUnit?: 'kmh' | 'mph'
}) => {
  const url = '/report/harvester'
  return (dispatch: Dispatch) =>
    http
      .post(url, data)
      .then((res) => {
        dispatch(
          showModal(
            <Alert severity="success">
              {t('report_request_message') || 'Request Received'}
            </Alert>,
            {},
          ),
        )
      })
      .catch((error) => {
        console.error('Failed to start harvester report', error)
        dispatch(
          showModal(
            <Alert severity="error">
              {t('report_request_error_message') || 'Report request failed'}
            </Alert>,
            {},
          ),
        )
      })
}
